import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class SrcMappingContract {

  @JsonProperty()
  id: number;

  @JsonProperty()
  sourceCode: string | undefined;

  @JsonProperty()
  crystalExchangeCode: string | undefined;

  @JsonProperty()
  sourceContractCode: string | undefined;

  @JsonProperty()
  crystalContractCode: string | undefined;

  @JsonProperty()
  crystalContractType: SrcMappingContract.ContractType;

  @JsonProperty()
  source: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}

export module SrcMappingContract {
  export enum ContractType {
    BOTH = 'BOTH',
    FUTURE = 'FUTURE',
    OPTION = 'OPTION'
  }
}
